var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChipStatus',{attrs:{"color":_vm.statusColor(_vm.status),"colorImportant":_vm.statusColor(_vm.status, true),"important":_vm.requiresMyInput,"text":_vm.$t(("document.status." + _vm.statusValue))}})}
var staticRenderFns = []

export { render, staticRenderFns }